// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "362" ? "__federation_expose_App" : chunkId) + "." + {"362": "288b5cc6","396": "7867ed7a","75": "630edede",}[chunkId] + ".js"
}